import { Component, OnInit } from '@angular/core';
//import { LoginService } from '../pages/login/login.service';
import { Subscription, BehaviorSubject,Observable } from 'rxjs';
export interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}

export const ROUTES: RouteInfo[] = [
    { path: '/dashboard', title: 'Dashboard', icon:'nc-bank',  class: '' },
    { path: '/list-user', title: 'Users', icon:'nc-single-02',  class: '' },
    { path: '/list-user-setting', title: 'User Settings', icon:'nc-single-02',  class: '' },
    { path: '/list-plan', title: 'Subscription Plan', icon:'nc-credit-card',  class: '' },
    { path: '/list-transaction', title: 'Transaction', icon:'nc-money-coins',  class: '' },
    { path: '/firmware', title: 'Firmware', icon:'nc-app',  class: '' },
    { path: '/language', title: 'Audio Language', icon:'nc-layout-11',  class: '' },
    { path: '/audio', title: 'App Audio', icon:'nc-note-03',  class: '' },
    { path: '/static-page', title: 'Static Page', icon:'nc-paper',  class: '' },
    { path : '/email-template', title: 'Email Template', icon:'nc-tile-56',  class: ''},
    { path: '/change-password', title: 'Change Password', icon:'nc-circle-10',  class: '' },
];

@Component({
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    permissionObservable$: Observable<any>;
    constructor(
      //private loginService: LoginService
    ){}
    ngOnInit() {
      //this.permissionObservable$ =  this.loginService.userSubjectResponse;
        this.menuItems = ROUTES
        .filter(menuItem => menuItem);
    }

}
